/* RESPONSIBLE TEAM: team-automation-foundations */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

export default class EcommerceLoadingRoute extends GlobalLoadingRoute {}
